var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mypage-contract-us-page"},[_c('sub-header-section',{attrs:{"pageTitle":_vm.$tc('MypagePage.MypageContactUsPage.pageTitle'),"backLink":"/mypage"}}),_c('mypage-contact-us-pane')],1)}
var staticRenderFns = []

export { render, staticRenderFns }